
import React from 'react';
import { useAuth } from './context/AuthContext';
import AppRoutes from './components/AppRoutes';
import LayoutSelector from './components/LayoutSelector';

const AppContent = () => {
    const { loading } = useAuth();

    if (loading) {
        return <div className="loading-fullscreen">Loading...</div>;
    }

    return (
        <LayoutSelector>
            <AppRoutes />
        </LayoutSelector>
    );
};

export default AppContent;
